import { BaseObject } from './BaseObject';
import { SVGRenderer } from '../core/SVGRenderer';
import { Point2D } from '../types';
import { MathLabelRenderer } from '../utils/MathLabelRenderer';

export class Label extends BaseObject {
  public pos: Point2D;
  public text: string;
  private groupElem: SVGGElement | null = null;
  private textElem: SVGTextElement | null = null;

  constructor(
    renderer: SVGRenderer,
    pos: Point2D,
    text: string,
    id?: string
  ) {
    super(renderer, id);
    this.pos = { ...pos };
    this.text = text;
    this.render();
  }

  public render(): SVGElement {
    this.groupElem = this.renderer.createElement('g', {
      id: this.id,
      class: 'geom-label',
    });

    this.textElem = this.renderer.createElement('text', {
      x: this.pos.x,
      y: this.pos.y,
      fill: this.renderer.config.lineColor,
      'font-size': this.renderer.config.fontSize,
      'font-weight': '600',
      'font-family': this.renderer.config.fontFamily,
      'text-anchor': 'middle',
      'dominant-baseline': 'central',
    });
    this.textElem.textContent = MathLabelRenderer.format(this.text);

    this.groupElem.appendChild(this.textElem);
    this.renderer.layers.labels.appendChild(this.groupElem);
    this.element = this.groupElem;
    return this.groupElem;
  }

  public setPosition(x: number, y: number): void {
    this.pos.x = x;
    this.pos.y = y;
    this.update();
  }

  public setText(text: string): void {
    this.text = text;
    if (this.textElem) this.textElem.textContent = text;
  }

  public update(): void {
    if (this.textElem) {
      this.textElem.setAttribute('x', String(this.pos.x));
      this.textElem.setAttribute('y', String(this.pos.y));
    }
  }
}
